export default [
    // 公证员信息管理
    {
        path: '/NotaryAccount',
        name: '公证员信息管理',
        component: resolve => require(['../components/NotaryAccount/ShowNotaryAccountInfo'], resolve)
      },
    // 中介机构信息管理
    {
        path: '/IntermediaryInfo',
        name: '中介机构信息管理',
        component: resolve => require(['../components/IntermediaryInfo/ShowIntermediaryInfo'], resolve)
    },
    {
        path: '/Entrustment',
        name: '委托书内容管理',
        component: resolve => require(['../components/NotaryOffice/Entrustment'], resolve)
    },
    {
        path:'/IntermediaryInfo/form',
        name:'中介信息表单',
        component:resolve=>require(['../components/IntermediaryInfo/Form'],resolve)
    },
    {
      path: '/Supervision',
      name: '监管订单审核管理',
      component: resolve => require(['../views/Supervision/ShowSupervision'], resolve)
    },
    {
      path: '/Withdrawal',
      name: '提款出款申请',
      component: resolve => require(['../views/Withdrawal/ShowWithdrawal'], resolve)
    },
    {
      path: '/SuperviseBank',
      name: '按揭银行管理',
      component: resolve => require(['../views/SuperviseBank/index'], resolve)
    },
    {
      path: '/ProtocolTemplate',
      name: '资金监管协议管理',
      component: resolve => require(['../views/ProtocolTemplate/index'], resolve)
    },
    {
      path: '/WithdrawalConditions',
      name: '提款条件管理',
      component: resolve => require(['../views/WithdrawalConditions/index'], resolve)
    },
    {
      path: '/InvoiceManage',
      name: '开票管理',
      component: resolve => require(['../views/InvoiceManage/index'], resolve)
    },
]



// WEBPACK FOOTER //
// ./src/router/notaryoffice.js